<template>
  <div>
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="user_data">
      <vx-card title class="mb-base" id="page-user-view">
        <div class="vx-row">
          <div class="vx-col flex-1" id="account-info-col-1">
            <table v-if="user_data.iscompany">
              <tr>
                <td class="font-semibold">Type</td>
                <td>Company</td>
              </tr>
              <tr>
                <td class="font-semibold">Company</td>
                <td>{{ user_data.company_name }}</td>
              </tr>
            </table>
            <table v-else>
              <tr>
                <td class="font-semibold">Type</td>
                <td>Person</td>
              </tr>
              <tr>
                <td class="font-semibold">Firstname</td>
                <td>{{ user_data.firstname }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Lastname</td>
                <td>{{ user_data.lastname }}</td>
              </tr>
              <tr v-if="user_data.idcompany">
                <td class="font-semibold">Company</td>
                <td>
                  <a href="#" @click="ViewCompany">{{ user_data.Company.company_name }}</a>
                </td>
              </tr>
              
                  <tr>
                    <td class="font-semibold">Reliability</td>
                    <td v-if="user_data.reliability === 0">
                      <vs-chip color="danger">{{ user_data.reliability }}/5</vs-chip>
                    </td>
                    <td v-else-if="user_data.reliability === 1">
                      <vs-chip color="danger">{{ user_data.reliability }}/5</vs-chip>
                    </td>
                    <td v-else-if="user_data.reliability === 2">
                      <vs-chip color="warning">{{ user_data.reliability }}/5</vs-chip>
                    </td>
                    <td v-else-if="user_data.reliability === 3">
                      <vs-chip color="warning">{{ user_data.reliability }}/5</vs-chip>
                    </td>
                    <td v-else-if="user_data.reliability === 4">
                      <vs-chip color="success">{{ user_data.reliability }}/5</vs-chip>
                    </td>
                    <td v-else-if="user_data.reliability === 5">
                      <vs-chip color="success">{{ user_data.reliability }}/5</vs-chip>
                    </td>
                    <td v-else>
                      <vs-chip color>not defined</vs-chip>
                    </td>
                  </tr>
                  
                  <tr>
                    <td class="font-semibold">Category</td>
                    <td v-if="this.categoryPerson">
                      <vs-chip color>{{ this.categoryPerson }}</vs-chip>
                    </td>
                    <td v-else>
                      <vs-chip color>not applicable</vs-chip>
                    </td>
                  </tr>
            </table>
          </div>
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td v-if="user_data.iscompany" class="font-semibold">Address</td>
                <td v-else class="font-semibold">Personal Address</td>
                <td>
                  <tr v-for="(val, id) in user_data.addresses" :key="id">
                    <vs-td>
                      <u>{{ val.addresscategory.name_en }}</u>
                      <p v-if="val.place.province">
                        {{ val.street }} {{ val.number }},
                        <br />
                        {{ val.place.postal_code }} {{ val.place.place_name }} ({{ val.place.province }}),
                        <br />
                        {{ val.place.region }}, {{ val.place.country.name_en }}
                      </p>
                      <p v-else>
                        {{ val.street }} {{ val.number }},
                        <br />
                        {{ val.place.postal_code }} {{ val.place.place_name }} ({{ val.place.region }}),
                        <br />
                        {{ val.place.country.name_en }}
                      </p>
                      Latitude:{{ val.place.latitude }} Longitude:{{ val.place.longitude }}
                      <br />
                      <vs-button
                        @click="getDistance(val.place.latitude,val.place.longitude)"
                      >Find closest people</vs-button>
                    </vs-td>
                  </tr>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </vx-card>

      <vx-card title="Closest Person/Company" class="mb-base">
        <template>
          <div id="data-list-list-view" class="data-list-container">
            <vs-table ref="table" :data="data">
              <template slot="thead">
                <vs-th>Distance</vs-th>
                <vs-th>Category</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Name</vs-th>
                <vs-th>Reliability</vs-th>
                <vs-th>Address Type</vs-th>
                <vs-th>Action</vs-th>
              </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.distance }} km</vs-td>
                    <vs-td v-if="tr.string_agg"><vs-chip color="">{{ tr.string_agg }}</vs-chip></vs-td>
                    <vs-td v-else><vs-chip color="">not applicable</vs-chip></vs-td>
                    <vs-td>
                      <p v-if="tr.iscompany">Company</p>
                      <p v-else>Person</p>
                    </vs-td>
                    <vs-td>
                      <p v-if="tr.iscompany">{{ tr.company_name }}</p>
                      <p v-else>{{ tr.firstname }} {{ tr.lastname }}</p>
                    </vs-td>
                    <vs-td>
                      <p v-if="tr.reliability === 0">
                        <vs-chip color="danger">{{ tr.reliability }}/5</vs-chip>
                      </p>
                      <p v-else-if="tr.reliability === 1">
                        <vs-chip color="danger">{{ tr.reliability }}/5</vs-chip>
                      </p>
                      <p v-else-if="tr.reliability === 2">
                        <vs-chip color="warning">{{ tr.reliability }}/5</vs-chip>
                      </p>
                      <p v-else-if="tr.reliability === 3">
                        <vs-chip color="warning">{{ tr.reliability }}/5</vs-chip>
                      </p>
                      <p v-else-if="tr.reliability === 4">
                        <vs-chip color="success">{{ tr.reliability }}/5</vs-chip>
                      </p>
                      <p v-else-if="tr.reliability === 5">
                        <vs-chip color="success">{{ tr.reliability }}/5</vs-chip>
                      </p>
                      <p v-else>
                        <vs-chip color>not defined</vs-chip>
                      </p>
                    </vs-td>
                    <vs-td>
                      <p class="font-medium truncate">{{ tr.addressctg }}</p>
                    </vs-td>
                    <vs-td>
                      <feather-icon
                        icon="EyeIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        @click="openPerson(tr.id)"/>
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </div>
        </template>
      </vx-card>
    </div>
  </div>
</template>

<script>
import modulePersonList from "@/store/people/modulePersonList.js";
import axios from "@/axios.js";

export default {
  data() {
    return {
      user_data: null,
      data: {},
      user_not_found: false
    };
  },
  methods: {
    openPerson(id) {
      this.$router.push({ path: "/person/" + id });
    },
    async getDistance(lat, lng) {
      axios
        .get("/getdistance/" + this.user_data.id + "/" + lat + "/" + lng)
        .then(response => {
          this.data = [...response.data];
        });
    },
    ViewCompany() {
      window.location.replace("/person/" + this.user_data.Company.id);
    },
    getActiveColors(status) {
      if (status === true) return "primary";
      if (status === false) return "danger";
      return "warning";
    }
  },
  created() {
    if (!modulePersonList.isRegistered) {
      this.$store.registerModule("peopleList", modulePersonList);
      modulePersonList.isRegistered = true;
    }
    const userId = this.$route.params.userId;
    this.$store.dispatch("peopleList/fetchPerson", userId).then(res => {
      this.user_data = res.data;
    });
  }
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}
/*
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}*/

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }
}
/*
.vs-chip-success {
  background: rgba(var(--vs-success), 0.15);
  color: rgba(var(--vs-success), 1) !important;
  font-weight: 500;
}
.vs-chip-warning {
  background: rgba(var(--vs-warning), 0.15);
  color: rgba(var(--vs-warning), 1) !important;
  font-weight: 500;
}
.vs-chip-danger {
  background: rgba(var(--vs-danger), 0.15);
  color: rgba(var(--vs-danger), 1) !important;
  font-weight: 500;
}*/
</style>
